import GenericVModel from '@components/mixins/genericVModel'
import { position } from '@meta/widget/options.js'

export default {
  name: 'EditBlockPosition',
  mixins: [GenericVModel],
  props: {
    /**
     * The array is values only, use the values for both text and values
     */
    fortuneWheel: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      positionOptions: position,
    }
  }
}
